import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import App from './App';
import './i18n';
import './index.css';

// Handle native app entry: ?mode=app&accessToken=...&name=...
const params = new URLSearchParams(window.location.search);
if (params.get('mode') === 'app') {
  sessionStorage.setItem('appMode', 'true');
  // Save native auth token if present (from native Google/Facebook sign-in callback)
  const nativeToken = params.get('accessToken');
  if (nativeToken) {
    sessionStorage.setItem('nativeAuthToken', nativeToken);
    if (params.get('name')) sessionStorage.setItem('nativeAuthName', params.get('name'));
  }
  const returnTo = sessionStorage.getItem('nativeAuthReturnTo');
  sessionStorage.removeItem('nativeAuthReturnTo');
  window.location.replace(returnTo || '/app');
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);
